$(document).ready(function () {
  $(".header-desktop-search-button").click(function () {
    if ($(".site-header-search-container").hasClass("site-header-search-container-active")) {
      $(".site-header-search-container").removeClass("site-header-search-container-active");
      $("body").removeClass("bg-overlay");
    } else {
      $(".site-header-search-container").addClass("site-header-search-container-active");
      $("body").addClass("bg-overlay");
    }
  });

  $("#close-search-button").click(function () {
    $(".site-header-search-container").removeClass("site-header-search-container-active");
    $("body").removeClass("bg-overlay");
  });

  // range filter for price
  const allRanges = document.querySelectorAll(".col_price_filters");
  if (allRanges.length) {
    allRanges.forEach((wrap) => {
      const range = wrap.querySelector(".collection-filters__filter-range-input");
      const bubble = wrap.querySelector(".bubble");
      if (!range || !bubble) return;
      range.addEventListener("input", () => setBubble(range, bubble));
      setBubble(range, bubble);
    });

    function setBubble(range, bubble) {
      bubble.innerHTML = range.value;
    }

    const rangeMin = document.querySelector(".collection-filters__filter-range--from input");
    const rangeMax = document.querySelector(".collection-filters__filter-range--to input");
    const minValue = document.querySelector(".collection-filters__filter-range--from .bubble");
    const maxValue = document.querySelector(".collection-filters__filter-range--to .bubble");
    const sliderTrack = document.querySelector(".slider-track");

    if (rangeMin && rangeMax && minValue && maxValue && sliderTrack) {
      const minGap = 1;
      const sliderMaxValue = parseInt(rangeMax.max, 10) || 1;

      function fillColor() {
        const percent1 = (parseInt(rangeMin.value, 10) / sliderMaxValue) * 100;
        const percent2 = (parseInt(rangeMax.value, 10) / sliderMaxValue) * 100;
        sliderTrack.style.background = `linear-gradient(to right, #E8EEDB ${percent1}% , #A5251C ${percent1}% , #A5251C ${percent2}%, #E8EEDB ${percent2}%)`;
      }

      function updateRange(event) {
        let minVal = parseInt(rangeMin.value, 10);
        let maxVal = parseInt(rangeMax.value, 10);
        if (maxVal - minVal < minGap) {
          if (event.target === rangeMin) rangeMin.value = maxVal - minGap;
          else rangeMax.value = minVal + minGap;
        }
        minValue.textContent = rangeMin.value;
        maxValue.textContent = rangeMax.value;
        fillColor();
      }

      rangeMin.addEventListener("input", updateRange);
      rangeMax.addEventListener("input", updateRange);
      fillColor();
    }
  }

  // Remove Text from Frequently Bought Together App Section
  function handleTextRemoval() {
    function removeFirstTextNode() {
      document.querySelectorAll('.ctm_main_pdpd label[data-product-handle]').forEach(element => {
        if (element.firstChild && element.firstChild.nodeType === Node.TEXT_NODE) element.firstChild.remove();
      });
    }

    const interval = setInterval(() => requestAnimationFrame(removeFirstTextNode), 500);
    const observer = new MutationObserver((mutations, obs) => {
      mutations.forEach(mutation => {
        if (mutation.type !== 'childList') return;
        removeFirstTextNode();
        const target = document.querySelector('.ctm_main_pdpd label[data-product-handle]');
        if (target && (!target.firstChild || target.firstChild.nodeType !== Node.TEXT_NODE)) {
          clearInterval(interval);
          obs.disconnect();
        }
      });
    });

    requestAnimationFrame(() => {
      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
        removeFirstTextNode();
      }
    });
  }

  handleTextRemoval();

  // Hide empty BA Product Pro collapsible tabs.
  function hideEmptyBaProductTabs(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.ba-section-product-pro details.ba-pp__acc').forEach(tab => {
      const body = tab.querySelector('.ba-pp__acc-body');
      if (!body) return;
      const text = body.textContent.replace(/ /g, ' ').trim();
      const hasMeaningfulElement = body.querySelector('img, picture, video, audio, iframe, table, ul, ol, svg, figure, blockquote');
      tab.hidden = !text && !hasMeaningfulElement;
    });
  }

  hideEmptyBaProductTabs(document);
  document.addEventListener('shopify:section:load', function (event) {
    hideEmptyBaProductTabs(event.target || document);
  });
});

// BA Collection filters — behavior only.
// Visual styling is intentionally NOT injected here. BA Collection Sidebar is the
// single source of truth for border, spacing, typography, checkbox and panel design.
// Desktop (>= 990px): filter groups open and the sidebar is always expanded.
// Mobile (< 990px): groups stay closed and the filter row keeps the state rendered by
// BA Collection Grid (its "Show filters expanded on mobile" setting / active filters).
(function () {
  const PROCESSED = 'baNativeFiltersReady';
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  function isDesktop() {
    return desktopQuery.matches;
  }

  function prepForm(form) {
    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.disabled = input.value.trim() === '';
    });
  }

  function submitForm(form) {
    prepForm(form);
    HTMLFormElement.prototype.submit.call(form);
  }

  function openGroups(form) {
    form.querySelectorAll('details.ba-cg__dropdown').forEach(function (group) {
      if (!group.hidden && group.getAttribute('aria-hidden') !== 'true') group.open = true;
    });
  }

  function closeGroups(form) {
    form.querySelectorAll('details.ba-cg__dropdown[open]').forEach(function (group) {
      group.removeAttribute('open');
    });
  }

  function bindCleanForm(form) {
    form.addEventListener('change', function (event) {
      const target = event.target;
      if (target && (target.matches('input[type="checkbox"]') || target.matches('select'))) submitForm(form);
    });

    form.addEventListener('submit', function () {
      prepForm(form);
    });

    const row = form.querySelector('.ba-cg__filter-row');
    const toggle = form.querySelector('.ba-cg__mfilter-toggle');

    if (toggle && row) {
      toggle.addEventListener('click', function () {
        const collapsed = row.classList.toggle('is-collapsed');
        toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        if (collapsed) closeGroups(form);
      });
    }

    if (isDesktop()) {
      if (row) row.classList.remove('is-collapsed');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      openGroups(form);
    } else {
      closeGroups(form);
    }

    const priceGroup = row ? row.querySelector('details[data-filter-slot="price"]') : null;
    if (priceGroup) row.appendChild(priceGroup);
  }

  function makeIndependent(form) {
    if (!form || form.dataset[PROCESSED] === 'true') return form;
    const cleanForm = form.cloneNode(true);
    cleanForm.dataset[PROCESSED] = 'true';
    form.replaceWith(cleanForm);
    bindCleanForm(cleanForm);
    return cleanForm;
  }

  function initialize(scope, forceOpen) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const forms = [];
    if (root.matches && root.matches('form.ba-cg__toolbar')) forms.push(root);
    root.querySelectorAll('form.ba-cg__toolbar').forEach(function (form) { forms.push(form); });

    forms.forEach(function (form) {
      const current = makeIndependent(form) || form;
      if (!isDesktop()) return;
      if (forceOpen) openGroups(current);
      const row = current.querySelector('.ba-cg__filter-row');
      const toggle = current.querySelector('.ba-cg__mfilter-toggle');
      if (row) row.classList.remove('is-collapsed');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    });
  }

  function schedule(scope, forceOpen) {
    window.setTimeout(function () { initialize(scope || document, !!forceOpen); }, 0);
    window.setTimeout(function () { initialize(scope || document, !!forceOpen); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(document, true); });
  } else {
    schedule(document, true);
  }

  document.addEventListener('shopify:section:load', function () { schedule(document, true); });

  function onViewportChange() {
    if (isDesktop()) {
      schedule(document, true);
    } else {
      document.querySelectorAll('form.ba-cg__toolbar').forEach(closeGroups);
    }
  }
  if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onViewportChange);
  else if (desktopQuery.addListener) desktopQuery.addListener(onViewportChange);
})();

// Sort arrow only: mirror the filter chevron geometry and its actual right inset.
// This does not set filter design values and therefore does not block Theme Editor controls.
(function () {
  const STYLE_ID = 'ba-sort-arrow-alignment';

  function ensureSortArrowStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .ba-section-cg .ba-cg__sort select {
        -webkit-appearance: none !important;
        appearance: none !important;
        background-image: url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='none'%20stroke='%231a2744'%20stroke-width='2.4'%20stroke-linecap='round'%20stroke-linejoin='round'%3E%3Cpolyline%20points='6%209%2012%2015%2018%209'/%3E%3C/svg%3E") !important;
        background-repeat: no-repeat !important;
        background-position: right var(--ba-sort-arrow-inset, 0px) center !important;
        background-size: var(--ba-sort-arrow-size, 14px) var(--ba-sort-arrow-size, 14px) !important;
      }
    `;
    document.head.appendChild(style);
  }

  function alignSortArrow() {
    ensureSortArrowStyle();
    document.querySelectorAll('.ba-section-cg').forEach(function (section) {
      const select = section.querySelector('.ba-cg__sort select');
      const label = section.querySelector('details.ba-cg__dropdown:not([hidden]) > .ba-cg__dd-label');
      const chev = label ? label.querySelector('.ba-cg__chev') : null;
      if (!select || !label || !chev) return;

      const labelRect = label.getBoundingClientRect();
      const chevRect = chev.getBoundingClientRect();
      if (!labelRect.width || !chevRect.width) return;

      const rightInset = Math.max(0, Math.round(labelRect.right - chevRect.right));
      const size = Math.max(10, Math.round(chevRect.width));
      select.style.setProperty('--ba-sort-arrow-inset', rightInset + 'px');
      select.style.setProperty('--ba-sort-arrow-size', size + 'px');
    });
  }

  function scheduleAlign() {
    [0, 80, 180, 320].forEach(function (delay) { window.setTimeout(alignSortArrow, delay); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleAlign);
  else scheduleAlign();

  window.addEventListener('resize', scheduleAlign);
  document.addEventListener('shopify:section:load', scheduleAlign);
  document.addEventListener('shopify:section:select', scheduleAlign);
})();

// BA Collection Sidebar — live Theme Editor design bridge.
// The Sidebar and Grid are separate Shopify sections. Shopify can re-render the
// Sidebar alone while editing settings, so mirror its freshly-rendered CSS into
// <head> after every section update. This keeps the Sidebar as the single design
// source while making every unsaved Theme Editor control affect the Grid immediately.
(function () {
  const LIVE_STYLE_ID = 'ba-collection-sidebar-live-design';
  const LEGACY_STYLE_ID = 'ba-collection-native-filter-cards';
  const SIDEBAR_SELECTOR = '[id*="ba_collection_sidebar_patch"], [id*="ba-collection-sidebar-patch"]';
  const LEGACY_VARS = [
    '--ba-filter-card-bg',
    '--ba-filter-card-border-width',
    '--ba-filter-card-border-color',
    '--ba-filter-card-radius',
    '--ba-filter-card-gap'
  ];

  let observer = null;
  let debounceTimer = null;
  let syncing = false;

  function removeLegacyFilterDesign() {
    const staleStyle = document.getElementById(LEGACY_STYLE_ID);
    if (staleStyle) staleStyle.remove();

    document.querySelectorAll('.ba-section-cg details.ba-cg__dropdown').forEach(function (group) {
      LEGACY_VARS.forEach(function (name) {
        group.style.removeProperty(name);
      });
    });
  }

  function isSidebarCss(text) {
    return !!text &&
      text.indexOf('.ba-section-cg .ba-cg__filter-row') !== -1 &&
      text.indexOf('.ba-section-cg .ba-cg__sidebar-heading') !== -1 &&
      text.indexOf('.ba-section-cg .ba-cg__opt') !== -1;
  }

  function getFreshSidebarCss() {
    const sidebar = document.querySelector(SIDEBAR_SELECTOR);

    if (sidebar) {
      const localCss = Array.from(sidebar.querySelectorAll('style'))
        .filter(function (style) {
          return style.id !== LIVE_STYLE_ID &&
            style.id !== LEGACY_STYLE_ID &&
            isSidebarCss(style.textContent || '');
        })
        .map(function (style) { return style.textContent || ''; })
        .join('\n');

      if (localCss) return localCss;
    }

    const styles = Array.from(document.querySelectorAll('style')).filter(function (style) {
      return style.id !== LIVE_STYLE_ID &&
        style.id !== LEGACY_STYLE_ID &&
        isSidebarCss(style.textContent || '');
    });

    return styles.length ? (styles[styles.length - 1].textContent || '') : '';
  }

  function syncSidebarDesign() {
    if (syncing) return;
    syncing = true;

    try {
      removeLegacyFilterDesign();

      const css = getFreshSidebarCss();
      if (!css) return;

      let liveStyle = document.getElementById(LIVE_STYLE_ID);
      if (!liveStyle) {
        liveStyle = document.createElement('style');
        liveStyle.id = LIVE_STYLE_ID;
        document.head.appendChild(liveStyle);
      }

      if (liveStyle.textContent !== css) liveStyle.textContent = css;
    } finally {
      syncing = false;
    }
  }

  function scheduleSidebarDesignSync() {
    window.clearTimeout(debounceTimer);
    syncSidebarDesign();
    debounceTimer = window.setTimeout(syncSidebarDesign, 35);
    window.setTimeout(syncSidebarDesign, 120);
    window.setTimeout(syncSidebarDesign, 280);
  }

  function nodeTouchesSidebar(node) {
    if (!node || node.nodeType !== 1) return false;
    const element = node;

    if (element.id === LIVE_STYLE_ID || element.id === LEGACY_STYLE_ID) return false;
    if (element.matches && element.matches(SIDEBAR_SELECTOR)) return true;
    if (element.querySelector && element.querySelector(SIDEBAR_SELECTOR)) return true;
    if (element.tagName === 'STYLE' && isSidebarCss(element.textContent || '')) return true;

    return false;
  }

  function mutationTouchesSidebar(mutation) {
    const target = mutation.target && mutation.target.nodeType === 1
      ? mutation.target
      : mutation.target && mutation.target.parentElement;

    if (target && nodeTouchesSidebar(target)) return true;

    return Array.from(mutation.addedNodes || []).some(function (node) {
      return nodeTouchesSidebar(node);
    });
  }

  function startObserver() {
    if (observer || !document.documentElement) return;

    observer = new MutationObserver(function (mutations) {
      if (syncing) return;
      if (mutations.some(mutationTouchesSidebar)) scheduleSidebarDesignSync();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSidebarDesignSync();
      startObserver();
    });
  } else {
    scheduleSidebarDesignSync();
    startObserver();
  }

  window.addEventListener('load', scheduleSidebarDesignSync);
  document.addEventListener('shopify:section:load', scheduleSidebarDesignSync);
  document.addEventListener('shopify:section:select', scheduleSidebarDesignSync);
  document.addEventListener('shopify:section:reorder', scheduleSidebarDesignSync);
})();

// BA Collection Sidebar — use the existing Top filter area background setting
// for the desktop Sort/top block too. The setting is rendered into the Sidebar's
// mobile topbar CSS, so read that value from the section CSS and mirror it onto
// the desktop Sort wrapper. Filter dropdown/card backgrounds remain independent.
(function () {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  let observer = null;
  let timer = null;

  function extractTopAreaBackground() {
    const styles = [];
    const liveStyle = document.getElementById('ba-collection-sidebar-live-design');
    if (liveStyle) styles.push(liveStyle);

    document.querySelectorAll('[id*="ba_collection_sidebar_patch"] style, [id*="ba-collection-sidebar-patch"] style').forEach(function (style) {
      styles.push(style);
    });

    for (let i = styles.length - 1; i >= 0; i -= 1) {
      const css = styles[i].textContent || '';
      const match = css.match(/\.ba-section-cg\s+\.ba-cg__topbar\s*\{[^}]*background:\s*([^;!}]+)\s*!important/i);
      if (match && match[1]) return match[1].trim();
    }

    return '';
  }

  function syncDesktopTopAreaBackground() {
    const background = extractTopAreaBackground();

    document.querySelectorAll('.ba-section-cg .ba-cg__filter-row > .ba-cg__sort').forEach(function (sort) {
      if (!desktopQuery.matches || !background) {
        sort.style.removeProperty('background-color');
        return;
      }

      sort.style.setProperty('background-color', background, 'important');
    });
  }

  function scheduleSync() {
    window.clearTimeout(timer);
    syncDesktopTopAreaBackground();
    timer = window.setTimeout(syncDesktopTopAreaBackground, 40);
    window.setTimeout(syncDesktopTopAreaBackground, 140);
    window.setTimeout(syncDesktopTopAreaBackground, 300);
  }

  function startObserver() {
    if (observer || !document.documentElement) return;

    observer = new MutationObserver(function (mutations) {
      const relevant = mutations.some(function (mutation) {
        const target = mutation.target && mutation.target.nodeType === 1
          ? mutation.target
          : mutation.target && mutation.target.parentElement;

        if (target && target.tagName === 'STYLE') return true;
        return Array.from(mutation.addedNodes || []).some(function (node) {
          return node && node.nodeType === 1 && (node.tagName === 'STYLE' || (node.querySelector && node.querySelector('style')));
        });
      });

      if (relevant) scheduleSync();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSync();
      startObserver();
    });
  } else {
    scheduleSync();
    startObserver();
  }

  window.addEventListener('load', scheduleSync);
  window.addEventListener('resize', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:select', scheduleSync);
  document.addEventListener('shopify:section:reorder', scheduleSync);

  if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', scheduleSync);
  else if (desktopQuery.addListener) desktopQuery.addListener(scheduleSync);
})();
